export default __webpack_public_path__ + "static/media/logo.470d09bb.png";